import { Col, Row, Paragraph, Image } from 'Common';
import TextBlock from './TextBlock';
import { TEXT } from 'locales/translations';
import krankenkasseImage from 'images/home/krankenkasse-erstattungsfaehig-white.png';
import { ThemeContainer } from 'Container';
import { themeFeeling } from 'Theme';
import { HealthInsuranceSectionStyle } from './HealthInsuranceSection.style';
import { linkHandler } from 'utils/linkHandler';
import { Link } from 'Common';

export const HealthInsuranceSection = () => {
  return (
    <ThemeContainer theme={themeFeeling}>
      <HealthInsuranceSectionStyle id="health-section" backgroundColor="pink">
        <Row>
          <Col xs={{ size: 12 }} md={{ size: 7 }} lg={{ size: 5 }} className="health-image-wrapper order-2 order-md-1">
            <TextBlock heading={TEXT.healthPageSection.heading} />
            <TextBlock body={TEXT.healthPageSection.body} />
            <Paragraph className="bold">{TEXT.healthPageSection.subline} </Paragraph>
            <Link button color="pink" className="btn-pink600 text-uc" to={linkHandler.get('sda') + '#section-checkout'}>
              {TEXT.healthPageSection.btn}
            </Link>
          </Col>
          <Col className="content order-1 order-md-2" xs={{ size: 10, offset: 1 }} md={{ size: 5, offset: 0 }} lg={{ size: 5, offset: 2 }}>
            <Image alt={TEXT.healthPageSection.alt} src={krankenkasseImage} className="health-image" />
          </Col>
        </Row>
      </HealthInsuranceSectionStyle>
    </ThemeContainer>
  );
};
